module.exports = __webpack_public_path__ + "static/media/flags.4b605117.png";